import draw from './draw'
export default function (app) {
  app.directive('draw', draw)
}
